import { Box, Text, VStack } from "@chakra-ui/react"

export const CardDivider = () => (
  <Box w="1px" h="36px" bg="gray.200" flexShrink={0} />
)

export const CardMetric: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <VStack align="center" gap={0} minW="80px">
    <Text
      fontSize="10px"
      color="gray.400"
      fontWeight="medium"
      letterSpacing="0.6px"
      textTransform="uppercase"
    >
      {label}
    </Text>
    <Box mt={1}>{value}</Box>
  </VStack>
)
